import Vue from 'vue';
import ZkFrameworkVue from '@zk/framework-vue';
import { isOverseasVersion, isPrivateVersion, isSupportRecorderART } from '../util';

Vue.use(ZkFrameworkVue);
Vue.prototype.isOverseasVersion = isOverseasVersion;
Vue.prototype.isPrivateVersion = isPrivateVersion;
Vue.prototype.isSupportRecorderART = isSupportRecorderART;
